import React from 'react';
import GuestAccessCodeContainer from '../containers/guest_access_code_container';

const GuestAccessCodeContext = React.createContext(new GuestAccessCodeContainer());

export default GuestAccessCodeContext;
